import { useTranslation } from 'react-i18next'

import CustomerInfoSection from './CustomerInfoSection/CustomerInfoSection'
import LocationInfoSection from './LocationInfoSection/LocationInfoSection'

const ParcelInfoCardOutbound = ({
  senderAddress,
  senderName,
  recipientAddress,
  destinationAddress,
  customerEmail,
  onEditOutboundOriginLocation,
  allowEditOutboundOriginLocation,
  onEditOutboundDestinationAddress,
  allowEditOutboundDestinationAddress,
  onSendEmailToCustomer,
  allowSendEmail,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <LocationInfoSection
        title={t('Origen')}
        editTooltip={t('Editar origen')}
        address={senderAddress}
        locationName={senderName}
        locationLabel={t('Enviado desde')}
        onEdit={onEditOutboundOriginLocation}
        allowEdit={allowEditOutboundOriginLocation}
      />
      <CustomerInfoSection
        title={t('Destino')}
        editTooltip={t('Editar dirección destino')}
        sendEmailTooltip={t('Contactar con el cliente')}
        address={destinationAddress}
        contactAddress={recipientAddress}
        email={customerEmail}
        onEdit={onEditOutboundDestinationAddress}
        allowEdit={allowEditOutboundDestinationAddress}
        onSendEmail={onSendEmailToCustomer}
        allowSendEmail={allowSendEmail}
      />
    </>
  )
}

export default ParcelInfoCardOutbound
